export default "__VITE_ASSET__CYLZAIlQ__"